export const validateEmail = (email: string) => {
  //eslint-disable-next-line
  return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)/.test(email);
};

export const getDomainByEmail = (email: string): string => {
  return email.split("@")[1];
};
